module.exports = __webpack_public_path__ + "img/payment-landing-v3.f72ff46c.png";